import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../../utils/axios';
import '../../FormPage.css';

function TeacherRegistrationPage() {
  const [form, setForm] = useState({
    fullName: '',
    email: '',
    password: '',
    branch: '',
    experience: '',
    note: '',
  });
  const [message, setMessage] = useState({ type: '', text: '' });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage({ type: '', text: '' });

    try {
      await axios.post('/auth/register', {
        name: form.fullName,
        email: form.email,
        password: form.password,
        role: 'teacher',
        branch: form.branch,
        experience: form.experience,
        note: form.note,
      });

      setMessage({ 
        type: 'success', 
        text: '✅ Your application has been submitted successfully! Redirecting...' 
      });
      
      setTimeout(() => {
        navigate('/teacher-login');
      }, 2000);
    } catch (err) {
      setMessage({ 
        type: 'error', 
        text: '❌ Registration failed: ' + (err.response?.data?.msg || err.message) 
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="form-wrapper">
      <div className="form-container">
        <div className="form-box">
          <div className="form-header">
            <div className="form-icon">👨‍🏫</div>
            <h1>Teacher Application Form</h1>
            <p>Apply to become a part of our education team</p>
          </div>

          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-group">
              <label htmlFor="fullName">Full Name</label>
              <input
                type="text"
                id="fullName"
                name="fullName"
                placeholder="Your full name"
                value={form.fullName}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="example@email.com"
                value={form.email}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                name="password"
                placeholder="Create a strong password"
                value={form.password}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="branch">Branch/Subject</label>
              <input
                type="text"
                id="branch"
                name="branch"
                placeholder="e.g., Mathematics, English, Leadership"
                value={form.branch}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="experience">Experience Duration</label>
              <input
                type="text"
                id="experience"
                name="experience"
                placeholder="e.g., 5 years"
                value={form.experience}
                onChange={handleChange}
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="note">Additional Information</label>
              <textarea
                id="note"
                name="note"
                placeholder="Additional information about yourself and your experiences"
                value={form.note}
                onChange={handleChange}
                rows="4"
                className="form-textarea"
              />
            </div>

            <button 
              type="submit" 
              className="form-button"
              disabled={isLoading}
            >
              {isLoading ? 'Submitting...' : 'Submit Application'}
            </button>
          </form>

          {message.text && (
            <div className={`form-message ${message.type}`}>
              {message.text}
            </div>
          )}

          <div className="form-footer">
            <p>Already have an account? <a href="/teacher-login">Login here</a></p>
            <p><a href="/">← Back to home page</a></p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TeacherRegistrationPage;